<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-card *ngIf="teleconsultoEnabled">
          <ion-card-content>
            <ng-container>
              <div class="header-content">
                <ion-icon name="videocam-outline" class="header-icon"></ion-icon>
                <ion-card-title>Gruppi Pazienti per Televisita</ion-card-title>
              </div>
              <ion-toolbar>
                <h2>Gestisci Gruppi Pazienti per Televisita</h2>
                <ion-buttons slot="end" class="c3-flex-wrap ion-justify-content-end">
                  <ion-button c3Tooltip="Ricarica lista" (click)="getGroupsList()">
                    <ion-icon slot="icon-only" [src]="'refresh' | getIcon"></ion-icon>
                  </ion-button>
                  <ion-button color="secondary" fill="solid" (click)="addGroup('televisita')">
                    <span class="ion-hide-md-down">Crea Nuovo Gruppo</span>
                    <ion-icon slot="end" [src]="'plus' | getIcon"></ion-icon>
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>
              <table
                mat-table
                [dataSource]="dataSourceTele"
                [trackBy]="trackById"
                matSortActive="start_date"
                matSortDirection="desc"
                class="flex-fill"
                matSort
                #sortTele="matSort"
              >
                <ng-container matColumnDef="data_type">
                  <th
                    class="flex-45 justify-start items-end"
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                  >
                    Nome Gruppo
                  </th>
                  <td class="flex-45 justify-start items-center" mat-cell *matCellDef="let row">
                    <div class="flex items-center">
                      <span>{{ row?.groupName }}</span>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="start_date">
                  <th
                    class="flex-15 justify-start items-end"
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                  >
                    Data Creazione
                  </th>
                  <td class="flex-15 justify-start items-center" mat-cell *matCellDef="let row">
                    <span>{{ row?.createdDate | date: "dd-MM-yyyy" }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="patientsNumbers">
                  <th
                    class="flex-15 justify-start items-end"
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                  >
                    Pazienti
                  </th>
                  <td class="flex-15 justify-start items-center" mat-cell *matCellDef="let row">
                    <span>{{ row?.participantsGroup.length }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="spacer">
                  <th class="flex-5" mat-header-cell *matHeaderCellDef>&nbsp;</th>
                  <td class="flex-5" mat-cell *matCellDef="let row">&nbsp;</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th class="flex-10 justify-start items-end" mat-header-cell *matHeaderCellDef>
                    Azioni
                  </th>
                  <td class="flex-10 justify-start items-center" mat-cell *matCellDef="let row">
                    <button
                      mat-icon-button
                      matTooltip="Apri o Modifica"
                      (click)="openDetail(row, 'televisita')"
                    >
                      <mat-icon color="primary" svgIcon="information-outline"></mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      matTooltip="Cancella"
                      (click)="delete(row, 'televisita')"
                    >
                      <mat-icon color="warn" svgIcon="delete-circle"></mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedTeleconsultoColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedTeleconsultoColumns"></tr>
              </table>
              <div
                class="empty-msg-box d-flex flex-row justify-center items-center"
                *ngIf="groupsList.length === 0"
              >
                <i>
                  Non sono presenti gruppi. Inizia ad aggiungerli utilizzando i bottoni sopra la
                  tabella in alto a destra
                </i>
              </div>

              <mat-paginator
                #paginatorTele
                [pageSizeOptions]="[5, 10, 20]"
                [pageSize]="10"
                showFirstLastButtons
              ></mat-paginator>
            </ng-container>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <ion-card *ngIf="surveyEnabled">
          <ion-card-content>
            <div class="header-content">
              <ion-icon name="list-circle-outline" class="header-icon"></ion-icon>
              <ion-card-title>Gruppi Pazienti per Questionari</ion-card-title>
            </div>
            <ion-toolbar>
              <h2>Gestisci Gruppi Pazienti per Questionari</h2>
              <ion-buttons slot="end" class="c3-flex-wrap ion-justify-content-end">
                <ion-button c3Tooltip="Ricarica lista" (click)="getSurveyList()">
                  <ion-icon slot="icon-only" [src]="'refresh' | getIcon"></ion-icon>
                </ion-button>
                <ion-button
                  color="secondary"
                  fill="solid"
                  (click)="addQuestionnaireGroup('survey')"
                >
                  <span class="ion-hide-md-down">Crea Nuovo Gruppo</span>
                  <ion-icon slot="end" [src]="'plus' | getIcon"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
            <table
              mat-table
              [dataSource]="dataSourceSurvey"
              [trackBy]="trackById"
              matSortActive="start_date"
              matSortDirection="desc"
              class="flex-fill"
              matSort
              #sortSurvey="matSort"
            >
              <ng-container matColumnDef="data_type">
                <th
                  class="flex-45 justify-start items-end"
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Nome Gruppo
                </th>
                <td class="flex-45 justify-start items-center" mat-cell *matCellDef="let row">
                  <div class="flex items-center">
                    <span class="ml-2">{{ row?.name }}</span>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="start_date">
                <th
                  class="flex-15 justify-start items-end"
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Data Creazione
                </th>
                <td class="flex-15 justify-start items-center" mat-cell *matCellDef="let row">
                  <span>{{ row?.createDate | date: "dd-MM-yyyy" }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="patientsNumbers">
                <th
                  class="flex-15 justify-start items-end"
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Pazienti
                </th>
                <td class="flex-15 justify-start items-center" mat-cell *matCellDef="let row">
                  <span>{{ row?.users.length }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="spacer">
                <th class="flex-5" mat-header-cell *matHeaderCellDef>&nbsp;</th>
                <td class="flex-5" mat-cell *matCellDef="let row">&nbsp;</td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th class="flex-10 justify-start items-end" mat-header-cell *matHeaderCellDef>
                  Azioni
                </th>
                <td class="flex-10 justify-start items-center" mat-cell *matCellDef="let row">
                  <button
                    mat-icon-button
                    matTooltip="Apri o Modifica"
                    (click)="openDetail(row, 'survey')"
                  >
                    <mat-icon color="primary" svgIcon="information-outline"></mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="Cancella" (click)="delete(row, 'survey')">
                    <mat-icon color="warn" svgIcon="delete-circle"></mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedSurveyColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedSurveyColumns"></tr>
            </table>
            <div
              class="empty-msg-box d-flex flex-row justify-center items-center"
              *ngIf="dataSourceSurvey.data.length === 0"
            >
              <i>
                Non sono presenti gruppi. Inizia ad aggiungerli utilizzando i bottoni sopra la
                tabella in alto a destra
              </i>
            </div>

            <mat-paginator
              #paginatorSurvey
              [pageSizeOptions]="[5, 10, 20]"
              [pageSize]="10"
              showFirstLastButtons
            ></mat-paginator>
          </ion-card-content>
        </ion-card>
      </ion-col> </ion-row></ion-grid
></ion-content>
